import moment from "moment-timezone";

/** OEM general settings currency code (e.g. EUR, PKR). Never a symbol. */
export const quoteCurrencyCode = (currency?: string | null) =>
  (currency || "EUR").toUpperCase();

export const formatQuoteAmount = (
  value?: number | null,
  currency?: string | null,
) => {
  const code = quoteCurrencyCode(currency);
  if (value == null) return `${code} 0`;
  return `${code} ${Number.isInteger(value) ? value : value.toFixed(2)}`;
};

export const formatQuoteDate = (
  value?: string | null,
  dateFormat = "DD/MM/YYYY",
) => {
  if (!value) return "—";
  const m = moment(value);
  if (!m.isValid()) return "—";
  return m.format(dateFormat);
};

export const isQuoteExpired = (quote: {
  status?: string | null;
  validUntilDate?: string | null;
}) => {
  if (!quote.validUntilDate) return false;
  const end = new Date(quote.validUntilDate);
  end.setHours(23, 59, 59, 999);
  return end.getTime() < Date.now();
};

/** Expired display/state (matches sidebar displayStatus === EXPIRED). */
export const isQuoteExpiredState = (
  quote?: {
    status?: string | null;
    validUntilDate?: string | null;
  } | null,
) => {
  if (!quote) return false;
  if (quote.status === "EXPIRED") return true;
  return isQuoteExpired(quote) && quote.status !== "APPROVED";
};

/** False when quote content must not be edited (approved or expired). */
export const isQuoteContentEditable = (
  quote?: {
    status?: string | null;
    validUntilDate?: string | null;
  } | null,
) => {
  if (!quote) return false;
  if (quote.status === "APPROVED") return false;
  if (isQuoteExpiredState(quote)) return false;
  return true;
};

export const canQuoteLinkWorkOrderAndPurchaseOrder = (
  quote?: {
    status?: string | null;
    validUntilDate?: string | null;
  } | null,
) => isQuoteContentEditable(quote) || quote?.status === "APPROVED";

/** True when Valid Until is set and still in the future (end of that day). */
export const isValidUntilInFuture = (validUntilDate?: string | null) => {
  if (!validUntilDate) return false;
  const end = new Date(validUntilDate);
  if (Number.isNaN(end.getTime())) return false;
  end.setHours(23, 59, 59, 999);
  return end.getTime() >= Date.now();
};
